import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import instance from "../axios/global";
import ClientSummaryTable from "../components/ClientSummaryTable";
import CreateClient from "../components/CreateClient";
import LoaderComp from "../components/LoaderComp";
import NavClient from "../components/NavClient";

const Clients = () => {
  const navigate = useNavigate();
  const [summary, setSummary] = useState(null);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [timing, setTiming] = useState(null);
  const requestId = useRef(0);

  const loadClients = useCallback(async () => {
    const currentRequest = ++requestId.current;
    const startedAt = performance.now();
    setLoading(true);
    setError("");
    try {
      const response = await instance.get("/client/all/summary");
      if (currentRequest !== requestId.current) return;
      const apiFinishedAt = performance.now();
      console.info(`[Clients] API : ${Math.round(apiFinishedAt - startedAt)} ms`);
      console.info(`[Clients] Tableau : ${response.data.clients.length} clients, ${response.data.months.length} mois (10 clients et 12 mois affichés par page)`);
      setSummary(response.data);
      setTiming({ startedAt, apiFinishedAt });
    } catch (requestError) {
      if (currentRequest !== requestId.current) return;
      console.warn(`[Clients] Échec API après ${Math.round(performance.now() - startedAt)} ms`);
      setError("Impossible de charger les clients.");
    } finally {
      if (currentRequest === requestId.current) setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadClients();
    return () => { requestId.current += 1; };
  }, [loadClients]);

  useEffect(() => {
    if (loading || !timing) return undefined;
    let secondFrame;
    const firstFrame = requestAnimationFrame(() => {
      secondFrame = requestAnimationFrame(() => {
        const finishedAt = performance.now();
        console.info(`[Clients] Affichage : ${Math.round(finishedAt - timing.apiFinishedAt)} ms`);
        console.info(`[Clients] Total : ${Math.round(finishedAt - timing.startedAt)} ms`);
      });
    });
    return () => {
      cancelAnimationFrame(firstFrame);
      if (secondFrame) cancelAnimationFrame(secondFrame);
    };
  }, [loading, timing]);

  const visibleClients = (summary?.clients || []).filter((client) =>
    client.name.toLocaleLowerCase("fr").includes(search.toLocaleLowerCase("fr")),
  );

  return (
    <div className="container-all-clients">
      <h1>Clients</h1>
      <div className="div-total-create-client">
        <NavClient />
        <div className="filter-create-client">
          <input
            className="search-bar"
            type="search"
            placeholder="Rechercher un client"
            aria-label="Rechercher un client"
            value={search}
            onChange={(event) => setSearch(event.target.value)}
          />
          <CreateClient onCreated={loadClients} />
        </div>
      </div>

      {loading ? <LoaderComp /> : error ? (
        <p role="alert">{error}</p>
      ) : visibleClients.length === 0 ? (
        <p>Aucun client à afficher.</p>
      ) : (
        <ClientSummaryTable
          key={search}
          months={summary.months}
          rows={visibleClients}
          firstColumn="Nom"
          onRowClick={(id) => navigate(`/clients/${id}`)}
        />
      )}
    </div>
  );
};

export default Clients;
